<template>
  <div>

    <div class="tipinfo">
      本操作，用于将【悦享工资条】作为"企业微信第三方应用"集成到客户自己的企业微信内，方便员工从企业微信中查看工资条明细。
    </div>
    <div class="title">
      第一步，点击下方按钮进入授权页面，企业微信管理员扫码授权。
    </div>
    <div class="addqywx" @click="toqywx">
      <img src="@/assets/qywxadd.png" alt="" style="width: 45px" />
      <div class="addtext">点击填加本应用到企业微信</div>
    </div>
    <div style="" class="linkto" v-if="linkflag">
      若未自动跳转（如Firefox、Safari有弹窗拦截），则点击 <el-button class="linkto" style="color:red" type="text" @click="linkto">手动跳转</el-button>
    </div>
    <!-- <el-image :src="require('@/assets/wk/wk1.png')" :preview-src-list="srcList">
    </el-image> -->
    <!-- <div class="title">
      第二步，由企业微信管理员扫描跳转出来的二维码进行授权。
    </div> -->
    <!-- <el-image :src="require('@/assets/wk/wk2.png')" :preview-src-list="srcList">
    </el-image> -->
    <div class="title">
      第二步，设置可见范围后，点击“同意以上授权并添加”（可见范围，建议修改为全公司，以保证每位员工都可以收到通知）
    </div>
    <el-image :src="require('@/assets/wk/wk3.png')" :preview-src-list="srcList">
    </el-image>
    <div class="infobox">
      <div class="iconbox">
        <i class="el-icon-info"></i>
        注意：
      </div>
      <div class="infotext">
        1、企业员工需在企业微信工作台找到“悦享工资条”应用，并进行授权登陆后，方可正常接收到工资条推送消息
      </div>
      <div class="infotext">
        2、企业微信试用期为60天，受企业微信规则限制，试用期满，需要每年每个人花5元钱进行续费，如下图所示：
      </div>
    </div>
    <!-- <div class="title" style="color:red">
      注意：
    </div>
    <div class="title" style="color:red">
      1. 企业员工需在企业微信工作台找到“悦享工资条”应用，并进行授权登录之后，方可正常接收到工资条推送消息
    </div>
    <div class="title" style="color:red">
      2. 企业微信试用期为60天，受企业微信规则限制，试用期满，需要每年花1元钱进行续费，如下图所示：
    </div> -->
    <el-image :src="require('@/assets/wk/wk4.png')" :preview-src-list="srcList">
    </el-image>
    <el-image :src="require('@/assets/wk/wk5.png')" :preview-src-list="srcList">
    </el-image>
    <!-- <el-image :src="require('@/assets/wk/wk3.png')" :preview-src-list="srcList">
    </el-image> -->
    <!-- <img src="@/assets/wk/wk2.png" alt="" />
    <img src="@/assets/wk/wk3.png" alt="" /> -->
    <!-- <div class="title">第三步，搜索"悦享工资条"，添加应用</div>
    <el-image :src="require('@/assets/wk/wk4.png')" :preview-src-list="srcList">
    </el-image> -->
    <!-- <img src="@/assets/wk/wk4.png" alt="" /> -->
    <!-- <div class="title">
      第四步，联系客服扫描二维码授权，下方为客服企业微信联系方式和微信联系方式
    </div>
    <div>
      <el-image :src="require('@/assets/workvxkf.jpg')" :preview-src-list="srcList" style="width: 350px">
      </el-image>
      <el-image :src="require('@/assets/kf.jpeg')" :preview-src-list="srcList" style="width: 350px">
      </el-image>
    </div> -->

    <!-- <div class="title">第五步，授权通过后选择可见范围，创建应用</div> -->
    <!-- <el-image :src="require('@/assets/wk/wk5.png')" :preview-src-list="srcList">
    </el-image> -->
    <!-- <img src="@/assets/wk/wk5.png" alt="" /> -->

    <!-- <p>1.管理员统一配置</p>
    <p>
      管理员需要登录企业微信后台，在【应用管理】>>【应用】>>【自建应用】中，选择创建应用。
    </p> -->
  </div>
</template>

<script>
// import p1 from '@/assets/wk/wk1.png'
// import p2 from '@/assets/wk/wk2.png'
import p3 from '@/assets/wk/wk3.png'
import p4 from '@/assets/wk/wk4.png'
// import p5 from '@/assets/workvxkf.jpg'
// import p6 from '@/assets/kf.jpeg'
import p7 from '@/assets/wk/wk5.png'
import { qywxauthor } from '@/api/setUp.js'

export default {
  data () {
    return {
      srcList: [p3, p4, p7],
      url: '',
      linkflag: false
    }
  },
  methods: {
    async toqywx () {
      // let url = 'https://open.work.weixin.qq.com/3rdapp/install?suite_id=ww46…en%2FauthRedirect&state=3bea90c7-87e7-48d9-a4e7-ac8eadb4cb12'
      let { data } = await qywxauthor()
      this.url = data
      this.linkflag = true
      window.open(data);

      // url = data
      // const btn = document.querySelector('#myButton');
      // btn.addEventListener('click', function () {
      //   window.open(url);
      // });
      // btn.click();
    },
    linkto () {
      window.open(this.url);
      // const btn = document.querySelector('#myButton');
      // btn.click();
    }
  },
}
</script>

<style less="lang" scoped>
h1 {
  line-height: 60px;
}
img {
  width: 90%;
  margin: 15px 0;
}
.title {
  font-weight: 550;
  font-size: 16px;
  line-height: 55px;
}
.tipinfo {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #000000;
  line-height: 24px;
  margin-bottom: 5px;
}

.addqywx {
  width: 360px;
  height: 140px;
  background: rgba(59, 196, 146, 0.1);
  border-radius: 3px;
  border: 1px dashed #3bc492;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  /* margin-bottom: 24px; */
}
.addtext {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.7);
  line-height: 20px;
}
.linkto {
  font-size: 14px;
  line-height: 14px;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 55px;
  font-weight: 550;
}
.infobox {
  width: 100%;
  background: rgba(230, 34, 41, 0.05);
  border-radius: 4px;
  padding: 15px 0 12px 16px;
  margin: 12px 0;
}
.iconbox {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
}
.iconbox > i {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #e73339;
  line-height: 20px;
}

.infotext {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0a1629;
  line-height: 24px;
}
</style>
